import React from 'react';
import { Link } from 'react-router-dom';
import KineticHeadline from '../motion/KineticHeadline';
import Reveal from '../motion/Reveal';
import Magnetic from '../motion/Magnetic';
import Claws from '../motion/Claws';
import Parallax from '../motion/Parallax';
import SectionLight from '../motion/SectionLight';
import { formatLockTime } from './eventUtils';

const HOLE = 'radial-gradient(ellipse 60% 40% at 50% 50%, transparent 0%, transparent 55%, #000 100%)';

/** FINAL CTA: the end card. Huge kinetic line, claws framing it, the next card's lock time. */
export default function FinalCta({ event }) {
  const lock = event && event.status !== 'locked' && event.status !== 'completed' ? formatLockTime(event.date) : null;
  return (
    <section className="pnp-section pnp-final" aria-labelledby="pnp-final-title">
      <SectionLight bleed="60px">
        <div className="pnp-octagrid" style={{ opacity: 0.7 }} />
        <div className="pnp-glow pnp-glow-center" style={{ top: '50%', marginTop: -550, width: 1100, height: 1100 }} />
        <Reveal rise={false} style={{ position: 'absolute', inset: 0, WebkitMaskImage: HOLE, maskImage: HOLE }}>
          <Parallax speed={-0.08} max={80} style={{ position: 'absolute', inset: 0 }}>
            <Claws className="pnp-final-claws-l" />
            <Claws className="pnp-final-claws-r" />
          </Parallax>
        </Reveal>
      </SectionLight>
      <div className="pnp-wrap">
        <div id="pnp-final-title">
          <KineticHeadline as="h2" className="pnp-display pnp-final-title" text={'The card is set.\n*Your move.*'} />
        </div>
        <Reveal delay={420}>
          <p className="pnp-lead">
            {lock ? <>Picks for <strong style={{ color: '#fff' }}>{event.name}</strong> lock {lock}. </> : null}
            It&apos;s free, it takes a minute, and the trash talk starts the moment you&apos;re in.
          </p>
        </Reveal>
        <Reveal delay={560} className="pnp-final-ctas">
          <Magnetic>
            <Link to="/register" className="pnp-btn pnp-btn-primary pnp-btn-lg">Join free <span className="pnp-btn-arrow" aria-hidden="true">→</span></Link>
          </Magnetic>
          <Magnetic strength={0.2}>
            <Link to="/join/TITLESHOT" className="pnp-btn pnp-btn-ghost pnp-btn-lg">Enter the Title Shot</Link>
          </Magnetic>
        </Reveal>
      </div>
    </section>
  );
}
